import BarChartIcon from '@mui/icons-material/BarChart';
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { Box, Grid, Typography } from '@mui/material';
import React from 'react';
import { publicCardSx, publicColors, publicContainerSx, publicH2Sx, publicSectionSx, publicSubtitleSx } from './publicTheme';

const blocks = [
    {
        icon: ShoppingCartIcon,
        title: 'Venda sem perder o controle',
        pain: 'Instagram, WhatsApp, loja parceira, feira livre, encomenda ou marketplace.',
        solution: 'Registre suas vendas, pedidos e clientes em um só lugar. Faça orçamentos, acompanhe encomendas e mantenha seu histórico organizado.',
    },
    {
        icon: PrecisionManufacturingIcon,
        title: 'Saiba o que está acontecendo na produção',
        pain: 'Pare de depender de planilhas e anotações para acompanhar seus pedidos.',
        solution: 'Registre suas impressões, acompanhe custos, materiais e máquinas. Com o Farm Link, monitore suas impressoras de diversas marcas em tempo real*.',
    },
    {
        icon: BarChartIcon,
        title: 'Tome decisões sabendo os números',
        pain: 'Quanto custa produzir? Quanto você realmente ganha? O que vale a pena vender?',
        solution: 'Tenha custos, vendas e resultados organizados para entender o seu negócio e tomar decisões com mais segurança.',
    },
];

const PlatformDetails = () => (
    <Box id="plataforma" component="section" sx={{ ...publicSectionSx, bgcolor: publicColors.surface }}>
        <Box sx={publicContainerSx}>
            <Typography component="h2" sx={{ ...publicH2Sx, textAlign: 'center' }}>
                Tudo o que você precisa para cuidar do seu negócio
            </Typography>
            <Typography sx={{ ...publicSubtitleSx, textAlign: 'center', mb: 5 }}>
                Vendas, produção, custos e finanças conectados para você saber o que está vendendo, quanto está 
                gastando e quanto realmente está ganhando com cada venda.
            </Typography>
            <Grid container spacing={3}>
                {blocks.map(({ icon: Icon, title, pain, solution }) => (
                    <Grid item xs={12} md={4} key={title}>
                        <Box sx={publicCardSx}>
                            <Box
                                sx={{
                                    width: 48,
                                    height: 48,
                                    borderRadius: 1.5,
                                    bgcolor: publicColors.primarySoft,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    mb: 2,
                                }}
                            >
                                <Icon sx={{ color: publicColors.primary, fontSize: 28 }} />
                            </Box>
                            <Typography variant="h6" sx={{ fontWeight: 700, color: publicColors.ink, mb: 1.5 }}>
                                {title}
                            </Typography>
                            <Typography variant="body2" sx={{ color: publicColors.danger, fontWeight: 600, mb: 1 }}>
                                {pain}
                            </Typography>
                            <Typography variant="body2" sx={{ color: publicColors.inkMuted, lineHeight: 1.65 }}>
                                {solution}
                            </Typography>
                        </Box>
                    </Grid>
                ))}
            </Grid>
            <Typography
                variant="caption"
                display="block"
                textAlign="center"
                sx={{ mt: 4, color: publicColors.inkSoft }}
            >
                Recursos marcados com * estão disponíveis apenas para os planos pagos.
                <br />
                O Acompanha 3D é o único sistema de gestão que conecta com impressoras das principais fabricantes como <strong>Bambu Lab, Creality, Anycubic, Flashforge</strong>, entre outras.
            </Typography>
        </Box>
    </Box>
);

export default PlatformDetails;
